import './index.css'
import React from 'react'
import View from './view.js'
import useIsHovered from 'Logic/useIsHovered.js'

export default function Logic(props) {
  let [isHoveredManual, , hoverBind] = useIsHovered({
    isDisabled: false,
    isSelected: false,
  })
  let [hoveredName, , hoverNameBind] = useIsHovered({
    isDisabled: false,
    isSelected: false,
    onMouseEnterDelay: 500,
  })

  return (
    <View
      isHoveredManual={isHoveredManual}
      onMouseEnter={hoverBind.onMouseEnter}
      onMouseLeave={hoverBind.onMouseLeave}
      hoveredName={hoveredName}
      onMouseEnterName={hoverNameBind.onMouseEnter}
      onMouseLeaveName={hoverNameBind.onMouseLeave}
      {...props}
    />
  )
}
